import { AccountSelectProps } from '@components'

import { useCallback } from 'react'

import { BankAccountSelect } from '@features/bankAccounts/elements/BankAccountSelect'

import { EmberRoute } from '../../../../enums/emberRoute'
import { useEmberRouteToUrlGenerator } from '../../../../hooks/routing/useEmberRouteToUrlGenerator'
import { useEmberTransitionTo } from '../../../../hooks/routing/useEmberTransitionTo'
import { BankReconciliationAccountSelectAddAccount } from './elements/BankReconciliationAccountSelectAddAccount'

interface BankReconciliationAccountSelectProps extends AccountSelectProps {
  selectedId: string
  route?: EmberRoute
  withConnectNewAccountAction?: boolean
}

export const BankReconciliationAccountSelect = ({
  selectedId,
  route = EmberRoute.Bank,
  withConnectNewAccountAction,
  ...rest
}: BankReconciliationAccountSelectProps) => {
  const { transitionTo } = useEmberTransitionTo()
  const { generateUrl } = useEmberRouteToUrlGenerator()

  const handleBankAccountSelect = useCallback(
    (id?: string) => {
      if (generateUrl) {
        const url = generateUrl(route, id)
        transitionTo(url)
      }
    },
    [generateUrl, transitionTo, route],
  )

  return (
    <BankAccountSelect
      selectedId={selectedId}
      onSelect={handleBankAccountSelect}
      dropdownFooter={withConnectNewAccountAction ? <BankReconciliationAccountSelectAddAccount /> : undefined}
      {...rest}
    />
  )
}
